import type { Nullable } from '@mentimeter/ts-utils';
import type { RatingStaticContent } from '@core-api/editor/types/response';
import type { Question } from '@mentimeter/legacy-series-types/question';

type AxisLabels = Nullable<
  Pick<
    RatingStaticContent['interactiveContentStyling'],
    'xAxisLabels' | 'yAxisLabels'
  >
>;

export const ratingAxisLabelsToQuestionDimensions = ({
  xAxisLabels,
  yAxisLabels,
}: AxisLabels): Question['dimensions'] => {
  return [
    {
      label: xAxisLabels?.axisLabel ?? '',
      min: xAxisLabels?.minimumValueLabel ?? '',
      max: xAxisLabels?.maximumValueLabel ?? '',
    },
    {
      label: yAxisLabels?.axisLabel ?? '',
      min: yAxisLabels?.minimumValueLabel ?? '',
      max: yAxisLabels?.maximumValueLabel ?? '',
    },
  ];
};
